import { FC, useState } from 'react'
import { ArrowLeftCircleIcon, HomeIcon, UserCircleIcon } from '@heroicons/react/20/solid'
import { useDetectClickOutside } from 'react-detect-click-outside'
import { destoryUser, useAppDispatch, useAppSelector } from '../../redux'
import { Avatar } from '..'
import { StyledHeader } from '.'

const Header: FC = () => {
  const [showMenu, setShowMenu] = useState(false)
  const { avatar } = useAppSelector((state) => state.user)
  const dispatch = useAppDispatch()
  const ref = useDetectClickOutside({ onTriggered: (e) => handleMenuClose(e) })

  const handleMenuClose = (e: Event) => {
    const target = e.target as any

    if (target.closest('.avatar-btn')) {
      return
    }

    setShowMenu(false)
  }

  return (
    <StyledHeader>
      <header>
        <div className="logo">
          <HomeIcon/>
          Homie
        </div>
        <button className="avatar-btn" onClick={() => setShowMenu(!showMenu)}>
          <Avatar emoji={avatar}/>
        </button>
        {showMenu && (
          <div className="user-menu" ref={ref}>
            {/* <button><UserCircleIcon/> Change Avatar</button> */}
            <button onClick={() => dispatch(destoryUser())}><ArrowLeftCircleIcon/> Log out</button>
          </div>
        )}
      </header>
    </StyledHeader>
  )
}

export default Header
